<template>
  <div
    :class="[content.theme, { 'h-100': !isHauteurPageAutomatique }]"
    class="d-flex flex-column main-compte"
  >
    <vue-headful
      :title="titrePage"
      :description="content.description"
      :keywords="content.keywords"
      :image="metaOGImage"
      :url="metaUrl"
      :head="{
        'meta[name=robots]': { content: metaNoIndex },
        'link[hreflang=en-ca]': { href: pathAnglais },
        'link[hreflang=fr-ca]': { href: pathFrancais },
        'link[rel=apple-touch-icon]': { type: 'image/png' },
        'link[rel=icon]': { type: 'image/png' },
      }"
    />

    <!-- Ces 2 spans évitent erreur dans barreconnect-app.js -->
    <!-- TODO: À corriger dans lq-entete-connexion -->
    <!-- TODO: 2022-01-21 à détruire? ATTTENTION, utilisé dans 1c. Conserver cette ligne cause un doublon au niveau des id de la page. -->
    <!-- <span id="mel-topNotif"></span><span id="mel-notif"></span> -->

    <div class="w-100 h-100 d-flex align-items-center">
      <keep-alive>
        <main class="d-flex align-items-center h-100 px-0 col-md-12">
          <EditableArea v-if="content.main" class="w-100 h-100" :content="content.main" />
          <IframeHtmlSalesforce v-if="content.clavardage" :positionBulle="content.positionBulle" />
        </main>
      </keep-alive>
      <Aide :idRubriqueAide="content.idRubriqueAide"> </Aide>
    </div>

    <footer
      v-if="isPiedDePageVisible"
      id="footer"
      class="p-0"
      :class="$isMobile ? 'compteFonce' : content.themePiedDePage"
    >
      <Heritage class="piedDePage px-1" :content="contentHeritage" />
    </footer>
  </div>
</template>

<script>
import vueHeadful from 'vue-headful';

import { EditableArea } from '@/vue-editor';
import { bus } from '@/main';

import Aide from '@/components/Aide';
import Heritage from '@/components/base/Heritage';
import IframeHtmlSalesforce from '@/components/base/IframeHtmlSalesforce';

import { inAppMobile, inMgnl } from '@/helpers/AppHelpers';

export default {
  name: 'Compte',
  components: {
    EditableArea,
    Aide,
    Heritage,
    IframeHtmlSalesforce,
    vueHeadful,
  },
  inject: ['headerJsDisponible'],
  props: { metadata: { type: Object, required: true }, content: { type: Object, required: true } },
  data() {
    return {
      contentHeritage: { lienInterne: process.env.VUE_APP_JEL_NOEUD_PIEDDEPAGE },
      idQuestion: 0,
      metaUrl: document.URL,
      pathFrancais: '',
      pathAnglais: '',
      isHeaderJsAvaliable: this.headerJsDisponible,
    };
  },
  computed: {
    isPiedDePageVisible() {
      return (
        (!this.content.themePiedDePage || this.content.themePiedDePage != 'invisible') &&
        !inAppMobile()
      );
    },
    isHauteurPageAutomatique() {
      return this.content.hauteurPageAutomatique && !this.jel_isIPhoneOrIPod && !inAppMobile;
    },
    titrePage() {
      return `${this.content.title ? `${this.content.title} | ` : ''}Loto-Québec`;
    },
    metaOGImage() {
      return this.content.metaOGImage ? this.jel_getFichierSrc(this.content.metaOGImage) : '';
    },
    metaNoIndex() {
      return this.content.noindex == 'true' ? 'noindex' : 'index, follow';
    },
  },
  created() {
    const self = this;
    // TODO: déplacer ce code éventuellement dans le store navigation

    let lienBoutonAide = '';
    let targetBoutonAide = '_self';
    let typeBoutonAide = '';

    if (self.content.lienBoutonAide && self.content.idRubriqueAide == '') {
      if (self.content.lienBoutonAide.field === 'lienInterne') {
        lienBoutonAide = self.content.lienBoutonAide.lienInterne;
      } else if (self.content.lienBoutonAide.field === 'lienExterne') {
        lienBoutonAide = self.content.lienBoutonAide.lienExterne;
      }

      if (self.content.lienBoutonAide.isTargetBlank === 'true') {
        targetBoutonAide = '_blank';
      }

      typeBoutonAide = self.content.lienBoutonAide.field;
    }

    bus.$emit('NouvellePageMounted', {
      afficherNavigation: self.content.afficherNavigation === 'true',
      afficherPCU: self.content.afficherPCU === 'true',
      barreNavigation: 'compte',
      cacherLienPrecedent: self.content.cacherLienPrecedent === 'true',
      idRubriqueAide: self.content.idRubriqueAide,
      libSuperieurDroit1: self.content.themeAideNav?.libSuperieurDroit1,
      libSuperieurDroit2: self.content.themeAideNav?.libSuperieurDroit2,
      lienBoutonAide,
      lienSuperieurDroit: self.content.themeAideNav?.lienSuperieurDroit,
      lienYoutube: self.content.lienYoutube,
      targetBoutonAide,
      theme: self.content.theme,
      themeAideNav: self.content.themeAideNav?.field ?? self.content.theme,
      themeLogoNav: self.content.themeLogoNav ?? self.content.theme,
      typeBoutonAide,
    });

    // Dans le cas où le paramètre aide ne contient pas de liste,
    // this.$route.query.aide sera égal à null.
    // Il faut donc uniquement valider quand la valeur est undefined
    if (this.$route.query.aide != undefined) {
      // TODO: Valider le comportement en mobile
      this.toggleAideAvecQuestionId(this.$route.query.aide);
    }
    this.verifStoreUpdate();
  },
  mounted() {
    if (!this.isHeaderJsAvaliable) {
      this.$router.push({ path: '/erreur/indisponible' });
    }
    const self = this;
    document.body.scrollTop = 0; // forcer la page à charger en haut de page pour régler un problème sur mobile

    bus.$on('toggleAide', (idQuestion) => {
      self.toggleAideAvecQuestionId(idQuestion);
    });
    if (this.$store.state.aide.idRubriqueAideActuelle != this.content.idRubriqueAide) {
      /*
      TODO: Traiter le cas de "aide" dans l'URL.
      let query = Object.assign({}, this.$router.query);
      delete query.aide;

      history.pushState({}, null, this.metaUrl + "?aide=" + encodeURIComponent(id));
      this.$router.replace({ query });
      */

      this.$store.dispatch('aide/initRubriqueAide', {
        idRubriqueAide: this.content.idRubriqueAide,
        lienYoutube: this.content.lienYoutube,
      });
    }
    if (this.content.message != null) {
      // TODO: Tout ce code devrait être imbriqué dans le store
      const listeMsg = this.obtenirListeMessages(this.content.message);
      const listeMsgStore = this.$store.getters['message/getListeMessages'];
      for (let i = 0; i < listeMsg.length; i++) {
        let isMsgEnregistre = false;

        for (let k = 0; k < listeMsgStore.length; k++) {
          if (listeMsgStore[k].msgCode == listeMsg[i].msgCode) {
            // Si le code est le même, mais que le texte des messages diffère, celui de la page courante remplace celle dans le store
            if (listeMsgStore[k].msgDetail != listeMsg[i].msgDetail) {
              this.$store.commit('message/SET_MESSAGE', {
                index: k,
                message: listeMsg[i],
              });
            }

            isMsgEnregistre = true; // message dejà dans le store. Non ajouté
            break;
          }
        }
        if (!isMsgEnregistre) {
          // message ajouté dans le store
          this.$store.commit('message/ADD_MESSAGE', listeMsg[i]);
        }
      }
    }
    const uri = this.$store.getters['routes/getPathAutreLangue'](window.location.pathname.slice(3));
    this.miseAJourMetaLien(uri);

    // TODO: Revoir le chargement du css pour ne pas qu'il soit constamment ré-exécuté (à essayer dans le created mais idéalement revoir le chargement à la source)
    // Empêcher le logo Loto-Québec de la barre portail de s'afficher momentanément pleine grandeur
    if (!inMgnl) {
      if (this.content.afficherPCU) {
        const style = document.createElement('link');
        style.rel = 'stylesheet';
        style.type = 'text/css';
        style.href = '/mel/.resources/lq-entete-commun/webresources/css/barreportail-app.css?v=210';
        document.head.append(style);
      }
    }

    // Enregistrer dans le store si la barre PCU est chargée ou non dans cette page compte
    const isAfficherBarrePCU = this.content.afficherPCU === 'true' && !inAppMobile();
    this.$store.commit('navigation/SET_BARRE_PCU', isAfficherBarrePCU);
  },
  beforeDestroy() {
    bus.$off('toggleAide');
  },
  methods: {
    toggleAide() {
      this.$store.dispatch('aide/toggleAide');
    },
    toggleAideAvecQuestionId(id) {
      this.idQuestion = id;
      if (this.isAideActif == false) {
        this.toggleAide();
      }
      bus.$emit('ouvrirZoneEscamotable', id);
      if (!this.$route.query.aide && id !== null) {
        window.history.pushState({}, null, `${this.metaUrl}?aide=${encodeURIComponent(id)}`);
      }
    },
    obtenirListeMessages(messages) {
      const listeMessages = [];
      let i = 0;
      while (messages[`message${i}`] != null) {
        const unMessage = messages[`message${i}`];

        listeMessages.push({
          msgCode: unMessage.msgCode,
          msgDetail: unMessage.msgDetail,
          msgTitre: unMessage.msgTitre,
          msgType: unMessage.msgType,
        });
        i++;
      }
      return listeMessages;
    },
    verifStoreUpdate() {
      const delay = process.env.VUE_APP_STORE_DELAY_MIN * 60 * 1000;
      const maintenant = Date.now();
      if (sessionStorage.getItem('@ce:compte') !== null) {
        if (maintenant - this.$store.getters['compte/getLastUpdate'] >= delay) {
          this.$store.dispatch('compte/reset');
        }
        if (maintenant - this.$store.getters['profile/getLastUpdate'] >= delay) {
          this.$store.dispatch('profile/reset');
        }
        if (maintenant - this.$store.getters['promo/getLastUpdate'] >= delay) {
          this.$store.dispatch('promo/reset');
        }
      }
    },
    miseAJourMetaLien(url) {
      this.pathFrancais = this.metaUrl.includes('/fr/')
        ? this.metaUrl
        : window.location.origin + url;
      this.pathAnglais = this.metaUrl.includes('/en/')
        ? this.metaUrl
        : window.location.origin + url;
    },
  },
};
</script>

<style lang="scss">
#fileUploadForm {
  display: none;
}
</style>
